import Vue from 'vue';
import VueI18n from 'vue-i18n';
import nl from './locales/nl.json';
import axios from 'axios';
import Axios from 'axios';
import { Constants } from '../../constants';

Vue.use(VueI18n);

const i18n = new VueI18n({
  fallbackLocale: 'nl',
  locale: 'nl',
  messages: {
    nl,
  },
});

export const interfaceLanguages = ['nl', 'fr', 'en'];

export const backendTranslationNamespace = 'be';

const loadedLanguages: string[] = [];

function setI18nLanguage(lang: string): string {
  i18n.locale = lang;
  axios.defaults.headers.common['Accept-Language'] = lang;
  return lang;
}

export async function loadLanguage(lang: string = window.navigator.language.slice(0, 2)): Promise<string> {
  if (!interfaceLanguages.some(l => l === lang)) {
    lang = 'en'; // use nl as default if language is unknown
  }
  if (loadedLanguages.includes(lang)) {
    return setI18nLanguage(lang);
  }
  
  setI18nLanguage(lang);

  const msgs = await import(/* webpackChunkName: "lang-[request]" */ `@/shared/i18n/locales/${lang}.json`);
  const beTranslations = await Axios.get(`${Constants.ApiBaseUrl}modelTranslations`);
  const translations = {...msgs.default, [backendTranslationNamespace]: beTranslations.data};
  i18n.setLocaleMessage(lang, translations);
  loadedLanguages.push(lang);
  return lang;
}

export default i18n;
